module.exports = "img/rmoizo.78d546.png";